<template>
  <div @click="goDetail" class="item_box">
    <img v-lazy="$global.imgUrl + details.cover" class="cover" alt="" />
    <div class="content" style="margin-bottom: 20px; min-height: 55px">
      <h3 class="title" v-html="details.title"></h3>
      <span class="salePrice" v-if="details.saleType == 0">免费</span>
      <span class="salePrice" v-else>
        <span>¥</span>
        <span style="font-size: 20px; font-weight: 700">{{
          details.salePrice
        }}</span>
      </span>
    </div>
    <div class="content">
      <span class="time">{{ details.publisher }}</span>
      <span class="time">发布时间：{{ details.auditStatusTime ? details.auditStatusTime.slice(0, 10) :
        details.createTime.slice(0, 10) }}</span>
    </div>
    <!-- 弹窗二维码引导H5详情页 -->
    <Modal v-model="qrCodeModal" title="手机查看完整课程" class="" @on-cancel="qrCodeModal = false" :footer-hide="true">
      <div style="width:200px;height:200px;margin:20px auto;">
        <div id="qrcodeArea" ref="qrcodeArea">
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      qrCodeModal: false
    }
  },
  methods: {
    goDetail() {
      console.log(this.details)
      let routeUrl = this.$router.resolve({
        path: "/courseDetails",
        query: {
          type: 9,
          id: this.details.articleId ? this.details.articleId : this.details.id,
          goodsId:this.details.goodsId ? this.details.goodsId : "",
        },
      });
      // window.open(routeUrl.href, "_blank");
      // 弹窗显示二维码引导至H5查看详情
      this.qrCodeModal = true;
      if (!this.qr) {
        this.$nextTick(() => {
          // 生成H5
          this.qr = new QRCode(this.$refs.qrcodeArea, {
            width: 200,
            height: 200, // 高度
            text: location.protocol+'//'+location.hostname + routeUrl.href, // 二维码内容
          });

        })
      }
    },
  },
};
</script>

<style scoped lang="scss">
.item_box {
  margin-bottom: 30px;
  padding-bottom: 19px;
  width: 380px;
  box-shadow: 0px 0px 20px 0px rgba(22, 26, 100, 0.15);
  border-radius: 10px;
  border: 1px solid #eeeeee;
  cursor: pointer;
  overflow: hidden;

  .cover {
    margin-bottom: 10px;
    width: 100%;
    height: 214px;
  }

  &:hover .content .title {
    color: #0b35c5;
  }

  .content {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    .title {
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 18px;
      color: #333333;
    }

    .salePrice {
      font-size: 14px;
      color: #ff0000;
    }

    .time {
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>